import { Text } from "react-native-paper";
import { readableDate, readableTime } from "../../utils/dateUtils";
import { EventDetailsQuery } from "./types";

export function SuccessMessage({
  event,
  currentMember,
}: {
  event: EventDetailsQuery["event"];
  currentMember: EventDetailsQuery["currentMember"];
}) {
  const successMessages = {
    pat: () => (
      <>
        You have successfully registered for the Playing Ability Test at {event?.location} on{" "}
        {readableDate(new Date(event?.startsAt))} at {readableTime(new Date(event?.startsAt))}
      </>
    ),
    "pre-registration": () => (
      <>
        You have successfully pre-registered for the {event?.title}. An email confirmation has been sent to{" "}
        <Text className="font-700">{currentMember?.primaryEmail}.</Text>
      </>
    ),
    rsvp: () => (
      <>
        You have successfully pre-registered for the {event?.title}. An email confirmation has been sent to{" "}
        <Text className="font-700">{currentMember?.primaryEmail}.</Text>
      </>
    ),
    default: () => (
      <>
        You have successfully registered for the {event?.title}. An email confirmation has been sent to{" "}
        <Text className="font-700">{currentMember?.primaryEmail}.</Text>
      </>
    ),
  };

  const eventType: string = event?.eventType?.toLowerCase() as string;
  const successMessage = successMessages[eventType as keyof typeof successMessages] || successMessages.default;

  return <Text className="text-regular-normal text-center mt-4 px-4">{successMessage()}</Text>;
}
